import { useState, useEffect } from "react";
import axios from 'axios';
import { IGetGoToRequest, IWorkflowAjaxResult } from "./Models";
import qs from 'querystring';
import { getAntiForgeryToken } from "../../common/utils/Fetch";
const CancelToken = axios.CancelToken;
let cancel;

type IPropertiesApi = [string, IWorkflowAjaxResult, boolean, number, IGetGoToRequest, (t: IGetGoToRequest) => void, () => void];
export const useWorkflowApi: () => IPropertiesApi = () => {
    const [htmlContent, setHtmlContent] = useState<string>();
    const [jsonContent, setJsonContent] = useState<IWorkflowAjaxResult>();
    const [isLoading, setIsLoading] = useState(false);
    const [errorCode, setErrorCode] = useState<number>(200);
    const [goToReq, setGoToReq] = useState<IGetGoToRequest>(null);

    useEffect(() => {
        const fetchData = () => {
            setErrorCode(200);
            setIsLoading(true);
            setHtmlContent(null);
            setJsonContent(null);
            var params = { ...goToReq.params, "_": new Date().getTime()};

            axios.get(goToReq.url, {
                params: params,
                headers: {
                    'Cache-Control': 'no-cache',
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            })
                .then(function (response) {
                    let contentType: string = response.headers["content-type"];
                    setIsLoading(false);
                    if (contentType.startsWith("text/html;")) {
                        setHtmlContent(response.data);
                    }
                    else {
                        setJsonContent(response.data);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    setErrorCode(error.request?.status ?? 200);
                    setIsLoading(false);
                });
        };

        setHtmlContent(null);
        setJsonContent(null);

        if (!goToReq)
            return;

        fetchData();
    }, [goToReq]);

    function handleCancel() {
        if (cancel)
            cancel();

        setErrorCode(200);
    }

    return [htmlContent, jsonContent, isLoading, errorCode, goToReq, setGoToReq, handleCancel];
}

export function continueAjax(url: string, data, success: (data: any) => void, error: (e: IDefaultError) => void)
{
    data.__RequestVerificationToken = getAntiForgeryToken();
    var params = qs.stringify(data);
   
    axios.post(url, params, {
        headers: {
            'Cache-Control': 'no-cache',
        }
    })
        .then(function (response) {
            success(response.data);
        })
        .catch(function (er) {

            if (er.response) {
                error(er.response.data);
            } else {
                error({
                    success: false,
                    errorMessage: er.message,
                    extraMessage: "",
                    statusCode: er.request?.status,
                });
            }
            
            console.error(er.toJSON(), er);
        });
}

export interface IDefaultError {
    errorMessage: string;
    extraMessage: string;
    statusCode: number;
    success: boolean;
}